export default "__VITE_ASSET__DY_1lVRt__"